import { PRIMARY_LOCALE } from "routes/healthForms/types/common";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { CardContainer } from "routes/createContent/components/styles";
import { useGetTemplates } from "routes/createContent/api/useGetTemplates";
import { CatalogueDeploymentRow } from "routes/createContent/components/CatalogueDeploymentRow";
import { LibraryItem } from "../../components/LibraryItem/LibraryItem";
import { Link, useHistory } from "react-router-dom";
import { CataloguePath } from "routes/createContent/paths";
import { GroupIcon } from "shared/GroupIcon";
import { Loading } from "shared";
import { humanize } from "./constants";

export const Templates: React.VFC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { data: templates, isLoading, error } = useGetTemplates();
  const [search, setSearch] = useState("");
  const [group, setGroup] = useState("all");
  const [sort, setSort] = useState<"asc" | "desc">("asc");

  if (isLoading) {
    return <Loading />;
  }

  if (error) {
    return <p>{t("errors.generic")}</p>;
  }

  const named = (templates ?? []).map(template => ({
    template,
    name: String(template.name[PRIMARY_LOCALE.code] || template.id),
  }));
  const groups = Array.from(new Set(named.map(({ template }) => template.group ?? "other"))).sort();
  const shown = named
    .filter(({ name }) => name.toLowerCase().includes(search.trim().toLowerCase()))
    .filter(({ template }) => group === "all" || (template.group ?? "other") === group)
    .sort((a, b) => (sort === "asc" ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name)));

  return (
    <div>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <h1 style={{ margin: 0 }}>Templates</h1>
        <Button
          color="primary"
          variant="contained"
          startIcon={<Add />}
          component={Link}
          to={CataloguePath.Templates_New}
        >
          New template
        </Button>
      </Box>

      <Box display="flex" alignItems="center" mb={2} style={{ gap: 16 }}>
        <TextField
          variant="outlined"
          size="small"
          label="Search"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        <FormControl variant="outlined" size="small" style={{ minWidth: 180 }}>
          <InputLabel>Group</InputLabel>
          <Select label="Group" value={group} onChange={e => setGroup(e.target.value as string)}>
            <MenuItem value="all">All</MenuItem>
            {groups.map(g => (
              <MenuItem key={g} value={g}>
                {humanize(g)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl variant="outlined" size="small" style={{ minWidth: 120 }}>
          <InputLabel>Sort</InputLabel>
          <Select label="Sort" value={sort} onChange={e => setSort(e.target.value as "asc" | "desc")}>
            <MenuItem value="asc">A–Z</MenuItem>
            <MenuItem value="desc">Z–A</MenuItem>
          </Select>
        </FormControl>
        <Box flexGrow={1} />
        <Typography variant="h6">{shown.length} results</Typography>
      </Box>

      <CardContainer>
        {shown.map(({ template, name }) => {
          return (
            <LibraryItem
              key={template.id}
              author={undefined}
              checked={false}
              id={template.id}
              image={<GroupIcon group={template.group} />}
              title={name}
              bottomContent={
                <CatalogueDeploymentRow kind="template" name={template.key} rollout={template.rollout} compact />
              }
              onClick={() => {
                history.push(`${CataloguePath.Templates}/${template.id}`);
              }}
            />
          );
        })}
      </CardContainer>
    </div>
  );
};
